import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../../utils/Loader";
import {
  receipt_list_search_action, deleteReceipt_action, download_receipt_action
} from "../../../actions/accounts_action/receipt_action/receipt_action";
import { downloadReport, responseError } from "../../../utils/constants";
import Pagination from "../../../utils/pagination";
import Header from "../../../common_components/Header";
import moment from "moment";
import DatePicker from 'react-datepicker';
import MobileHeader from "../../../common_components/mobileHeader";
import Footer from "../../../common_components/Footer";

class ReceiptList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      user_id: "",
      receipt_id: "",
      ApplicantName: "",
      ReceiptNo: "",
      Description: "",
      StatusID: "",
      receiptList: [],
      Email: "",
      receiptDate: "",
      receiptTo: "",
      isAccordionExpanded: false,
      currentPage: 1,
      role_id: sessionStorage.getItem("role_id") != "" ? sessionStorage.getItem("role_id") : null
    };
  }

  componentDidMount() {
    if (JSON.parse(sessionStorage.getItem("AwardsUserLoginData")) == null) {
      setTimeout(() => {
        this.props.navigate("/login");
      }, 500);
    }
    setTimeout(() => {
      {
        sessionStorage.getItem("role_id") == 2 ? (
          this.props.navigate("/login")
        ) : <></>
      }
    }, 10);

    this.setState({
      user_id: sessionStorage.getItem("user_id") || "",
    });
    this.getReceiptList();
  }

  getReceiptList = () => {
    const { ApplicantName, receiptDate, receiptTo, ReceiptNo } = this.state;
    this.setState({ isLoading: true });
    this.props.receipt_list_search_action(ReceiptNo, ApplicantName,
      receiptDate != '' ? moment(receiptDate).format('YYYY-MM-DD') : null,
      receiptTo != '' ? moment(receiptTo).format('YYYY-MM-DD') : null,
    )
      .then((data) => {
        if (data.error !== 1) {
          this.setState({
            receiptList: data.data,
            isLoading: false,
            currentpage: 1,
          });
        } else {
          this.setState({ isLoading: false });
          responseError(data);
        }
      })
      .catch((e) => {
        console.log(e);
        this.setState({ isLoading: false });
      });
  }

  viewReceipt(application_form_id, receipt_id) {
    this.setState({ isLoading: true })
    this.props
      .download_receipt_action(application_form_id, receipt_id)
      .then((data) => {
        if (data.error != 1) {
          this.setState({ isLoading: false })
          // var url = `${downloadReport}?SessionIdentifier=${data}&Export=true`;
          const url = `${downloadReport}?SessionIdentifier=${data}`;
          window.open(url, "_blank", 'noopener,noreferrer');
        }
        else {
          this.setState({ isLoading: false })
          responseError(data);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  handleDelete = (receiptId) => {
    const confirmed = window.confirm(
      "Do you really want to delete this record?"
    );

    if (confirmed) {
      this.setState({ isLoading: true })
      this.props
        .deleteReceipt_action(receiptId)
        .then((data) => {
          if (data.error != 1) {
            this.setState({ isLoading: false })
            this.getReceiptList()
            toast.success("Deleted SuccessFully!", {
              theme: 'colored',
              autoClose: 3000,
              hideProgressBar: true,
            })
          }
          else {
            responseError(data)
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }

  navigateReceiptAdd = () => {
    this.props.navigate("/receiptManage", {
      state: { Is_add: true },
    });
  }

  navigateReceiptUpdate = (receipt_id) => {
    this.props.navigate(`/receiptManage`, {
      state: { receipt_id: receipt_id, Is_update: true },
    });
  }

  clearFilters = () => {
    this.setState({
      ApplicantName: "",
      receiptDate: "",
      ReceiptNo: "",
      receiptTo: "",
    }, () => {
      this.getReceiptList();
    });
  }

  updateItem = (item) => {
    this.setState({ currentPage: item });
  }
  receiptRecords(receiptList) {
    const { role_id } = this.state
    return (
      <table class="table table-bordered" id="dashboard-table">
        <thead>
          <tr >
            <th >Receipt No</th>
            {role_id != 4 && <th style={{ width: "18%" }}>Applicant Name</th>}
            <th className="text-center">Receipt Date</th>
            <th className="text-center">Taxable Amount</th>
            <th className="text-center">CGST</th>
            <th className="text-center">SGST</th>
            <th className="text-center">IGST</th>
            <th className="text-center">Receipt Amount</th>
            <th className="text-center">Outstanding</th>
            <th className="text-right" style={{ width: "80px" }}>
            </th>
          </tr>
        </thead>
        <tbody id="myTable">
          {receiptList.length > 0 ? (
            receiptList.map((data) => (
              <tr>
                <td>{data.receipt_no}</td>
                {role_id != 4 && <td>{data.company_name}</td>}
                <td className="text-center">{moment(data.receipt_date).format('DD/MM/YYYY')}</td>
                <td className="text-right">{data.taxable_amt != null ? data.taxable_amt.toLocaleString() : ''}</td>
                <td className="text-right">{data.cgst != null ? data.cgst.toLocaleString() : ''}</td>
                <td className="text-right">{data.sgst != null ? data.sgst.toLocaleString() : ''}</td>
                <td className="text-right">{data.igst != null ? data.igst.toLocaleString() : ''}</td>
                <td className="text-right">{data.grand_total != null ? data.grand_total.toLocaleString() : ''}</td>
                <td className="text-right">{data.outstanding != null ? data.outstanding.toLocaleString() : ''}</td>
                {role_id != 4 ? <td className="text-right">
                  <a
                    title="Edit"
                    className="btn btn-sm"
                    onClick={() => this.navigateReceiptUpdate(data.receipt_id)}
                  >
                    <i class="fa fa-pencil-square-o text-primary"></i>
                  </a>
                  {data.status_id == 1 ? (
                    <a
                      title="Delete"
                      className="btn btn-sm delete_record"
                      onClick={() => this.handleDelete(data.receipt_id)}
                    >
                      <i class="ri-delete-bin-line"></i>
                    </a>
                  ) : (
                    <></>
                  )}
                  <img src="img/pdf-icon.png" height={18} width={16}
                    title="view"
                    className="btn btn-sm"
                    onClick={() => this.viewReceipt(data.application_form_id, data.receipt_id)}
                  />
                </td> :
                  <td className="text-center">
                    {/* <a
                      title="view"
                      className="btn btn-sm"
                      onClick={() => this.viewReceipt(data.application_form_id, data.receipt_id)}
                    >
                      <i class="ri-eye-fill"></i>
                    </a> */}
                    <img src="img/pdf-icon.png" height={20} width={18}
                      title="view"
                      className="btn btn-sm"
                      onClick={() => this.viewReceipt(data.application_form_id, data.receipt_id)}
                    />
                  </td>
                }
              </tr>
            ))
          ) : (
            <td colSpan={12} className="text-center">
              No records found
            </td>
          )}
        </tbody>
      </table>
    );
  }
  viewAccountReceipt(userId, receiptId, receiptNo) {
    this.setState({ isLoading: true })
    this.props
      .download_account_receipt_action(userId, receiptId, receiptNo)
      .then((data) => {
        if (data.error != 1) {
          this.setState({ isLoading: false })
          var url = `${downloadReport}?SessionIdentifier=${data}&Export=true`;
          const win = window.location.replace(url, '_blank');
          if (win != null) {
            win.focus();
          }
        }
        else {
          responseError(data)
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  render() {
    const {
      isLoading,
      receiptList,
      currentPage,
      isAccordionExpanded,
      ApplicantName,
      Email,
      receiptDate,
      receiptTo,
      receipt_id,
      ReceiptNo,
      role_id
    } = this.state;
    const recordsPerPage = 10;
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    // Records to be displayed on the current page
    const currentRecords = receiptList.slice(
      indexOfFirstRecord,
      indexOfLastRecord
    );
    const nPages = Math.ceil(receiptList.length / recordsPerPage);

    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <>
          <main id="main">

            <div className="website-view">
              <Header data={[8]} />
            </div>
            <div className="mobile-view">
              <MobileHeader data={[8]} />
            </div>
            <section class='header_margin_top'>
              <div className="container-fluid">
                <div className="page-header">
                  <h2 class="mb-3 dashboard-tit  py-0 blog-name blog-name-1"> Receipt List</h2>
                  {role_id != 4 && !isLoading &&
                    <button class="btn btn-outline-primary search_btn w-auto" onClick={() => this.navigateReceiptAdd()}>Add Receipt</button>
                  }
                  {/* {role_id != 4 && !isLoading && <div >
                    <i class="ri-add-box-line" style={{ fontSize: "28px", cursor: 'pointer' }}></i>
                  </div>} */}
                </div>
                {role_id != 4 && !isLoading &&
                  <div className="search_accordion search_card">
                    <div className="panel-group" id="accordion">
                      <div className="panel panel-default">
                        <div
                          className="panel-heading accordion-toggle collapsed"
                          data-toggle="collapse"
                          data-parent="#accordion"
                          data-target="#collapseOne"
                          aria-expanded={isAccordionExpanded}
                          onClick={() =>
                            this.setState({
                              isAccordionExpanded: !isAccordionExpanded,
                            })
                          }
                        >
                          <h4 className="panel-title">Search</h4>
                          <div className="searched_items">
                            {ReceiptNo ? <>
                              <h5>
                                Receipt No : <span>{ReceiptNo}</span>
                              </h5>
                            </> : <></>}
                            {ApplicantName ? <>
                              <h5>
                                Applicant Name : <span>{ApplicantName}</span>
                              </h5>
                            </> : <></>}
                            {receiptDate ? <>
                              <h5>
                                Receipt From Date : <span>{receiptDate != '' && moment(receiptDate).format('DD/MM/YYYY')}</span>
                              </h5>
                            </> : <></>}
                            {receiptTo ? <>
                              <h5>
                                Receipt To Date: <span>{receiptTo != '' && moment(receiptTo).format('DD/MM/YYYY')}</span>
                              </h5>
                            </> : <></>}
                          </div>
                        </div>
                        <div
                          id="collapseOne"
                          className={`panel-collapse collapse ${isAccordionExpanded ? "show" : ""
                            }`}
                        >
                          <div className="panel-body">
                            <div className="row mr_0">
                              <div className="col-md-2 ml-2">
                                <label>Receipt No</label>
                                <input
                                  type="text"
                                  className="form-control search_form_control"
                                  placeholder="Enter Name"
                                  value={ReceiptNo}
                                  onChange={(e) =>
                                    this.setState({ ReceiptNo: e.target.value })
                                  }
                                />
                              </div>
                              <div className="col-md-2">
                                <label>Applicant Name</label>
                                <input
                                  type="text"
                                  className="form-control search_form_control"
                                  placeholder="Enter Name"
                                  value={ApplicantName}
                                  onChange={(e) =>
                                    this.setState({ ApplicantName: e.target.value })
                                  }
                                />
                              </div>
                              <div className="col-md-2">
                                <div className="form-group">
                                  <label>Receipt From Date</label>
                                  <DatePicker className="form-control"
                                    dateFormat="dd-MM-yyyy"
                                    selected={receiptDate}
                                    onChange={(date) => {
                                      this.setState({ receiptDate: date ? moment.utc(date).toDate() : '' })
                                    }}
                                    peekNextMonth
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    placeholderText="DD/MM/YYYY"
                                  />
                                </div>
                              </div>
                              <div className="col-md-2">
                                <div className="form-group">
                                  <label>Receipt To Date</label>
                                  <DatePicker className="form-control"
                                    dateFormat="dd-MM-yyyy"
                                    selected={receiptTo}
                                    onChange={(date) => {
                                      this.setState({ receiptTo: date ? moment.utc(date).toDate() : '' })
                                    }}
                                    peekNextMonth
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    placeholderText="DD/MM/YYYY"
                                  />
                                </div>
                              </div>

                              <div className="col-md-3">
                                <label>&nbsp;</label>
                                <button
                                  onClick={() => this.getReceiptList()}
                                  className="btn btn-outline-primary search_btn w-auto mr-2"
                                >
                                  Search
                                </button>
                                &nbsp;
                                <button
                                  onClick={this.clearFilters}
                                  className="btn btn-outline-danger search_btn w-auto "
                                >
                                  Clear Filters
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                }
                <div className="custom_table">
                  <div className="hack1">
                    <div className="hack2">
                      {this.receiptRecords(currentRecords)}
                      {receiptList.length > 0 ? (
                        <Pagination
                          nPages={nPages}
                          currentPage={currentPage}
                          setCurrentPage={this.updateItem}
                        />
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </main>

          <Footer />
          <ToastContainer />
        </>
      </>
    );
  }
}
const mapDispatchToProps = { receipt_list_search_action, deleteReceipt_action, download_receipt_action };

export default withRouter(
  connect(null, mapDispatchToProps)(ReceiptList)
);
